import React from "react";
import configData from "config/config.json";
import { Link } from "react-router-dom";

export const getBannerTableColums = (params?: any) => {
  return [
    {
      id: "order",
      label: `Order`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "copiedFrom",
      label: `Copied From`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
      renderCell: (row: any) => {
        const id = row?.copiedFrom;
        if (!id || id === "-") return "-";

        const url = configData.routes.homeBanners.edit.replace(":id", id);

        return React.createElement(
          Link,
          {
            to: url,
            target: "_blank",
            onClick: (e: any) => e.stopPropagation(),
            style: {
              color: "#007bff",
              textDecoration: "underline",
              cursor: "pointer",
              opacity: 1,
            },
          },
          id,
        );
      },
    },
    {
      id: "title",
      label: `Title`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "navigationPath",
      label: `Navigation Path`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "body",
      label: `Body`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "textColor",
      label: `Text Color`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isActiveText",
      label: `Is Active`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    { id: "thumbnail", label: "Preview" },
    { id: "actions", label: "Actions" },
  ];
};
